import { useState } from "react";
import styles from "./PremiumPopup.module.css";
import { Activity, currentRequestTimeStamp } from "../../Constants";
import { useHistory } from "react-router-dom";
import { Urls } from "../../Urls";

const PopupCard = () => {
  const history = useHistory();
  const [visible, setVisible] = useState(true);

  const redirectToBilling = () => {
    history.push({ pathname: "/billing" });

    Activity([
      {
        screen: "Billings and Payments",
        module: "Billings and Payments",
        user_activity: "Premium Plans button clicked on side popup card",
        timestamp: currentRequestTimeStamp(),
      },
    ]);
  };

  const handleClose = () => {
    setVisible(false);
  };

  const username = localStorage.getItem("userdetails") || "";

  if (!visible) return null;

  return (
    <div className={`${styles.popupWrapper}  ${styles.slideIn}`}>
      <div className={styles.popupCard}>
        <div className={`d-flex justify-content-between align-items-center`}>
          <img
            src={Urls.LorriLogoLogin}
            alt="Lorri Logo"
            className={styles.logo}
          />
          <button className={styles.closeButton} onClick={handleClose}>
            <i className="fa fa-times" />
          </button>
        </div>

        <hr className={styles.separator} />

        <h4 className={styles.username}>Hey {username}!</h4>
        <div className={`mb-3`}>
          Looking to save up to 10% on your freight costs and get the best-fit
          transporters?
        </div>
        <div className={`mb-3`}>
          Click <strong>Premium Plans</strong> below to find out how.
        </div>

        <div className={`my-2 mt-4 text-center`}>
          <button
            className={`btn btn-success btn-sm`}
            onClick={redirectToBilling}
          >
            Premium Plans
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopupCard;
